import { Outlet } from 'react-router-dom';
// import { allowedRoutes } from './utils';

export function UnprotectedLayout() {
  // const location = useLocation();
  // const showBackground = [...allowedRoutes, '/'].some((route) => location.pathname == route);

  return (
    <div style={{ backgroundImage: 'url(/background-home.svg)' }}>
      <div className="h-screen overflow-y-auto [@supports(height:100dvh)]:min-h-[100dvh]">
        <Outlet />
      </div>
    </div>
  );
}
